import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/graphql";
import {
  CHECK_METAL_PERCENTAGE_REQUIRED,
  CALCULATE_DUTY_WITH_METAL,
} from "@/graphql/product-catalogue/metal-percentage";


// Type definitions
export interface MetalPercentageCheckInput {
  htsCode: string;
  countryOfOrigin: string;
}

export interface MetalPercentageCheckResponse {
  isMetalPercentageRequired: boolean;
  applicableMetalRules: {
    _id: string;
    name: string;
    rules: {
      data: {
        _id: string;
        rate: number;
        authority: string;
        isMetal: boolean;
        valueBasis: string;
      }[];
    };
  }[];
}

export interface DutyCalculationInput {
  htsCode: string;
  countryOfOrigin: string;
  metalPercentage?: number;
  effectiveDate?: string;
}

export interface DutyCalculationBreakdown {
  columnName: string;
  originalRate: number;
  metalPercentage?: number;
  adjustedRate: number;
  applied: boolean;
  reason: string;
}

export interface DutyCalculationResponse {
  baseRate: number;
  metalAdjustedRate: number;
  totalRate: number;
  breakdown: DutyCalculationBreakdown[];
}

export const metalPercentageApi = createApi({
  reducerPath: "api/metalPercentage",
  tagTypes: ["MetalPercentage"],
  baseQuery,
  endpoints: (builder) => ({
    checkMetalPercentageRequired: builder.query<
      MetalPercentageCheckResponse,
      MetalPercentageCheckInput
    >({
      query: (input) => ({
        document: CHECK_METAL_PERCENTAGE_REQUIRED,
        variables: { input },
      }),
      transformResponse: (response: {
        checkMetalPercentageRequired: MetalPercentageCheckResponse;
      }) => response.checkMetalPercentageRequired,
    }),

    calculateDutyWithMetal: builder.query<
      DutyCalculationResponse,
      DutyCalculationInput
    >({
      query: (input) => ({
        document: CALCULATE_DUTY_WITH_METAL,
        variables: { input },
      }),
      transformResponse: (response: {
        calculateDutyWithMetal: DutyCalculationResponse;
      }) => response.calculateDutyWithMetal,
    }),
  }),
});

export const {
  useCheckMetalPercentageRequiredQuery,
  useLazyCheckMetalPercentageRequiredQuery,
  useCalculateDutyWithMetalQuery,
  useLazyCalculateDutyWithMetalQuery,
} = metalPercentageApi; 